var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "select-option full-height cursor-pointer text-center round-borders generic-border q-py-lg q-px-lg shadow-1 bg-white",
      class: { active: _vm.active, wide: _vm.wide },
      on: {
        click: function($event) {
          _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm._t("default"),
      _c("span", { staticClass: "block q-mt-md q-title text-dark" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm.subtitle
        ? _c("span", { staticClass: "q-body-1 text-light" }, [
            _vm._v(_vm._s(_vm.subtitle))
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }